"use client";

import React, { useEffect, useRef, useState } from "react";
import { TripResult } from "@/types/trip.types";

export interface TripResultsTableProps {
  trip: TripResult | null;
  loading?: boolean;
  onLoaded?: () => void;
}

export default function TripResultsTable({
  trip,
  loading = false,
  onLoaded
}: TripResultsTableProps) {
  const hasReportedLoaded = useRef(false);
  const [isMobile, setIsMobile] = useState(false);

  // Track screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Trigger onLoaded once
  useEffect(() => {
    if (!hasReportedLoaded.current && !loading) {
      onLoaded?.();
      hasReportedLoaded.current = true;
    }
  }, [loading, onLoaded]);

  const headers = [
    "Distance",
    "Hours",
    "Minutes",
  ];

  const values = [
    loading ? "-" : trip?.distance_km != null ? `${trip.distance_km.toFixed(2)} km` : "-",
    loading ? "-" : trip?.hours ?? "-",
    loading ? "-" : trip?.minutes ?? "-",
  ];

  return (
    <div className="results-section">
      <h2 className="results-title">Trip Results</h2>

      <table className="trip-results-table" aria-label="Trip Results">
        {!isMobile ? (
          // Desktop horizontal table
          <>
            <thead>
              <tr>
                {headers.map((h, idx) => (
                  <th key={idx}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {values.map((v, idx) => (
                  <td key={idx}>{v}</td>
                ))}
              </tr>
            </tbody>
          </>
        ) : (
          // Mobile transposed table
          <tbody>
            {headers.map((header, idx) => (
              <tr key={idx}>
                <th>{header}</th>
                <td>{values[idx]}</td>
              </tr>
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
}
